import React from "react";
import FormLabelFieldPreview from "../form-label-field-preview/FormLabelFieldPreview";
import FindingItemPreview from "./FindingItemPreview";

const FindingGridPreview = props => {
  const {findings, categories, imageSize} = props;

  const getCategory = categoryId => {
    const id = Number(categoryId);
    const category = categories.find(c => String(c.id) === String(id));
    return category?.title || "";
  };

  return (
    <div className="table-responsive-sm">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">
              <FormLabelFieldPreview label="Id" />
            </th>
            <th>
              <FormLabelFieldPreview label="Hallazgo" />
            </th>
            <th>
              <FormLabelFieldPreview label="Observación" />
            </th>
            <th>
              <FormLabelFieldPreview label="Imagenes" />
            </th>
          </tr>
        </thead>
        <tbody>
          {findings.map(item => (
            <FindingItemPreview
              key={item.HallazgoId}
              category={getCategory(item.CategoriaId) || item.Hallazgo || ""}
              item={item}
              size={imageSize}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FindingGridPreview;
